"use client";

import { useSearchParams } from "next/navigation";
import { ReactNode, Suspense } from "react";
import LoadingSpinner from "@/components/ui/loading-spinner";

interface SearchParamsWrapperProps {
  children: ReactNode;
}

export default function SearchParamsWrapper({
  children,
}: SearchParamsWrapperProps) {
  const searchParams = useSearchParams();
  const token = searchParams.get("token");

  return <Suspense fallback={<LoadingSpinner />}>{children}</Suspense>;
}
